import { useState } from "react";
import { useAtomValue } from "jotai";
import { AppStateAtom } from "../../store";

interface UseAdminControllerReturn {
  isUserAdmin: boolean;
  activeTab: string;
  setActiveTab: (value: string) => void;
}

export const useAdminController = (): UseAdminControllerReturn => {
  const appState = useAtomValue(AppStateAtom);
  const isUserAdmin = appState.user?.role === "admin";
  const [activeTab, setActiveTab] = useState("audit");

  return {
    isUserAdmin,
    activeTab,
    setActiveTab,
  };
};
